import { createMuiTheme } from "@material-ui/core/styles";

//const defaultTheme = createMuiTheme({
//  typography: {
//    useNextVariants: true
//  }
//});

export default createMuiTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff"
    },
    background: {
      paper: "#fff",
      default: "#fff"
    },
    primary: {
      light: "rgba(28, 87, 165, 1)",
      main: "#285c74",
      dark: "rgba(52, 96, 148, 1)",
      contrastText: "#fff"
    },
    secondary: {
      light: "#ff4081",
      main: "#f50057",
      dark: "#c51162",
      contrastText: "#fff"
    },
    error: {
      light: "#e57373",
      main: "#f44336",
      dark: "#d32f2f",
      contrastText: "#fff"
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)"
    }
  },
  radio: {
    "&$checked": {
      color: "#4B8DF8"
    }
  },
  overrides: {
    MuiButton: {
      root: {
        backgroundColor: "#285c74",
        "&:hover": {
          backgroundColor: "rgba(40, 92, 116, 0.84) !important"
        }
      }
    },
    MuiTypography: {
      root: {
        fontSize: 15
      }
    },
    MuiRadio: {
      root: {
          color: '#e5e5e5 !important',
        "&$checked": {
          color: "#00add2 !important"
        }
      }
    },
    MuiFilledInput: {
      root: {
        "&$error": {
          border: "1px solid red"
        }
      }
    }
  }
});
